// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__KPuaT","content":"styles_content__2LTLC","row":"styles_row__3gJO-","footer":"styles_footer__26n1p","phraseLength":"styles_phraseLength__T2lLk"};